import "../../helpers/handlebars-helpers.js";
import {
  Observable,
  OperatorFunction,
  combineLatestWith,
  distinctUntilChanged,
  map,
  pipe as rxjsPipe,
  tap,
} from "rxjs";
import { includes } from "lodash-es";
import { UGElement } from "src/js/models/module.js";
import { ToggleableButton } from "../button/button.js";
import { IQueryService } from "src/js/services/query-service.js";
import { option } from "fp-ts";
import { pipe } from "fp-ts/lib/function.js";

export class MyFavoritesFilter {
  static FromButton(
    button: HTMLElement,
    FavoriteIds$: Observable<number[]>,
    queryService: IQueryService
  ): OperatorFunction<UGElement[], UGElement[]> {
    const showFavoritesQueryKey = "showFavorites";

    let initialState = pipe(
      queryService.get(showFavoritesQueryKey),
      option.map((queryValue) => queryValue === "true")
    );

    let ButtonState$ = ToggleableButton.getState$(button, initialState).pipe(
      tap((state) =>
        state
          ? queryService.set(showFavoritesQueryKey, "true")
          : queryService.remove(showFavoritesQueryKey)
      )
    );

    return rxjsPipe(
      combineLatestWith(ButtonState$, FavoriteIds$),
      map(([elements, isActive, favoriteIds]) =>
        isActive
          ? elements.filter((element) => includes(favoriteIds, element.id))
          : elements
      ),
      distinctUntilChanged()
    );
  }
}
